import Logger from '../util/Logger';
import _ from 'lodash';
import { RosterStatusType, rosterStatusTypeFromString } from './RosterStatusType';

export default {

  getId (status) {
    if (!status) {
      Logger.assert('Missing roster status');
    } else {
      const id = _.get(status, 'id');
      if (!id) {
        Logger.assert('RosterStatus is missing id');
      } else {
        return id;
      }
    }
  },

  getStatus (status) {
    if (!status) {
      Logger.assert('Missing roster status');
    } else {
      const stat = _.get(status, 'status') || RosterStatusType.FAILED;
      return rosterStatusTypeFromString(stat);
    }
  },

  getDescription (status) {
    if (!status) {
      Logger.assert('Missing roster status');
    } else {
      return _.get(status, 'status_description') || '';
    }
  }
};
